const isTouchDevice = () => {
    const prefixes = ['', '-webkit-', '-moz-', '-o-', '-ms-', ''];
    const mq = query => window.matchMedia(query).matches;

    if ('ontouchstart' in window ||
        (window.DocumentTouch && document instanceof window.DocumentTouch)
    ) {
        return true;
    }
    return mq(['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join(''));
};

const isElementInViewport = ($element) => {
    const el = $element[0];
    const rect = el.getBoundingClientRect();
    return (
        isTouchDevice() &&
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
};

export default isElementInViewport;



// WEBPACK FOOTER //
// ./src/scripts/components/global/isElementInViewport.js